// src/components/SEO/RentalSEO.jsx



// src/components/SEO/RentalSEO.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';

const RentalSEO = () => {
  const structuredData = {
    '@context': 'http://schema.org',
    '@type': 'Service',
    serviceType: 'Property Management',
    provider: {
      '@type': 'Organization',
      name: 'Tenant Guided Tours',
      url: 'https://tenantguided.tours',
      logo: 'https://tenantguided.tours/images/logo192.png',
      sameAs: [
        'https://www.facebook.com/tenantguided',
        'https://www.twitter.com/tenantguided',
        'https://www.linkedin.com/company/tenantguided',
        'https://www.instagram.com/tenantguided',
      ],
    },
    description:
      'Tenant Guided Tours provides automated property showings, smart lock access, and tenant screening for efficient rental management.',
    areaServed: {
      '@type': 'Place',
      name: 'United States',
    },
    offers: {
      '@type': 'Offer',
      priceCurrency: 'USD',
      price: '24.95',
      itemOffered: {
        '@type': 'Service',
        name: 'Smart Access Subscription',
      },
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+1-800-346-8999',
      contactType: 'Customer Support',
      areaServed: 'US',
      availableLanguage: 'English',
    },
  };

  return (
    <Helmet>
      <title>Tenant Guided Tours - Automated Property Showings for Rental Managers</title>
      <meta
        name="description"
        content="Tenant Guided Tours simplifies the rental process by automating property showings, providing remote access, and ensuring seamless scheduling and tenant screening for rental managers."
      />
      <meta
        name="keywords"
        content="tenant guided tours, property management, automated showings, smart locks, rental managers, tenant screening"
      />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://tenantguided.tours/rental-managers" />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Tenant Guided Tours - Automated Property Showings for Rental Managers"
      />
      <meta
        property="og:description"
        content="Discover a smarter way to manage property rentals. Tenant Guided Tours offers automated showings, remote access, and tenant screening for hassle-free leasing."
      />
      <meta property="og:url" content="https://tenantguided.tours/rental-managers" />
      <meta property="og:image" content="https://tenantguided.tours/images/rental-managers-preview.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        property="twitter:title"
        content="Tenant Guided Tours - Automated Property Showings for Rental Managers"
      />
      <meta
        property="twitter:description"
        content="Automate your property showings with Tenant Guided Tours. Efficient, secure, and fully managed leasing process for rental managers."
      />
      <meta property="twitter:url" content="https://tenantguided.tours/rental-managers" />
      <meta property="twitter:image" content="https://tenantguided.tours/images/rental-managers-preview.jpg" />
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
    </Helmet>
  );
};

export default RentalSEO;
